import { useDispatch, useSelector } from 'react-redux'
import { useMemo } from 'react'
import PageTitle from '../fragments/PageTitle'
import classes from './Tasks.module.css'

import { useTasksList } from '../../lib/hooks'
import { useParams } from 'react-router-dom'

import { tasksActions } from '../../store/tasks'
import TasksHeader from './TasksHeader'
import TasksRow from './TasksRow'
// import Pagination from './pagination/Pagination'
import TasksFiltersV2 from './TasksFiltersV2'
import MockRows from '../mock/MockRows'
import { tasks_table_header_cells } from '../../assets/data'
import Pagination from '../work_queues/pages/pagination/Pagination'
import { filterNotesByPermission } from '../../lib/notesPermissions'
import { omitDeletedRecords } from '../../lib/noteDelete'

export default function Tasks({caseIdFromDetails}) {
    const dispatch = useDispatch()
    const { caseId } = useParams()
    const loading = useSelector(state => state.tasks.loading)
    const snapshot = useSelector(state => state.tasks.snapshotData)
    const patientsList =  useSelector(state => state.tasks.currentpagedata)
    const editPermissions = useSelector(state => state.permissions.editPermissions)

    let caseID = caseId || caseIdFromDetails

    // get the referrals list from the hook 
    useTasksList(caseID, caseIdFromDetails)

    const visiblePatientsList = useMemo(() => {
        if (!patientsList?.data) {
            return patientsList
        }
        return {
            ...patientsList,
            data: omitDeletedRecords(filterNotesByPermission(patientsList.data, editPermissions)),
        }
    }, [patientsList, editPermissions])

    const visibleSnapshot = useMemo(() => {
        if (!snapshot?.data) {
            return snapshot
        }
        return {
            ...snapshot,
            data: omitDeletedRecords(filterNotesByPermission(snapshot.data, editPermissions)),
        }
    }, [snapshot, editPermissions])

    const setPatients = (patients) => {
        // setPatientsList(patients)
        dispatch(tasksActions.setCurrentPageData(patients))
        dispatch(tasksActions.setSnapshotData(patients)) // this is a snapshot to show because a loading page is bad! :))

    }


    return <>
        <div className={`${classes.header_box} ${caseIdFromDetails ? classes.header_tab : ''}`}>
            <div className='flex-container'>
                <PageTitle isContainer={caseIdFromDetails ? false : true} isInTab={caseIdFromDetails}>
                    My pending tasks    
                </PageTitle>  
            </div>  
            
            <TasksFiltersV2 />
        </div>
        <div className={`${caseIdFromDetails ? classes.body_container : ''}`}>
            <div className={`${caseIdFromDetails ? classes.body_container_inner : ''}`}>
                <table>
                    <TasksHeader isInTab={caseIdFromDetails}/>
                    {loading && !visibleSnapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        <MockRows numberOfRows={tasks_table_header_cells.length}/>
                    </tbody>}
                    {loading && visibleSnapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        {visibleSnapshot.data.map((item, index) => (
                            <TasksRow key={item.case_id + item.created_at} itemData={item} index={index} classes={classes} isInTab={caseIdFromDetails}/>
                        ))}
                    </tbody>}
                    {!loading && visiblePatientsList && visiblePatientsList.data && <tbody>
                        {visiblePatientsList.data.map((item, index) => (
                            <TasksRow key={item.id} itemData={item} index={index} classes={classes} isInTab={caseIdFromDetails}/>
                        ))}    
                    </tbody>}    
                    {!loading && !visiblePatientsList && <tbody>
                        <tr>
                            <td colSpan={tasks_table_header_cells.length}>No items found</td>    
                        </tr> 
                    </tbody>}         
                </table>                
            </div>

            {visiblePatientsList && visiblePatientsList.meta && <div className={`${classes.pagination_container} ${caseIdFromDetails ? classes.in_tab : ''}`}>
                {visiblePatientsList  && <Pagination data={visiblePatientsList} list={setPatients} apiType='tasks' hidePerPage={true} />}
            </div>}
        </div>
    </>
}
